import { jsx as _jsx } from "react/jsx-runtime";
import { CircularProgress, InputAdornment, makeStyles, TextField } from '@material-ui/core';
import { Search } from '@material-ui/icons';
import { Autocomplete } from '@material-ui/lab';
import { debounce } from 'lodash-es';
import React, { useCallback } from 'react';
const useStyles = makeStyles({
    option: {
        fontSize: '0.875rem'
    }
});
export const SearchBox = ({ placeholder, disabled, loading, searchInputChange, setSearchValue, valueChange, options = [], getValue = (i) => i.name, getOptionLabel = (i) => i.name, searchAnyKeyword = false, className, defaultValue, setPage, freeSolo = true, noOptionsText = 'No options', loadingText = false, searchOptionValue = false }) => {
    const classes = useStyles();
    const [isFocus, setIsFocus] = React.useState(false);
    const [valueSelected, setValueSelected] = React.useState(defaultValue);
    const setSearchValueDebounce = debounce((event, newInputValue) => {
        if (setSearchValue)
            setSearchValue(newInputValue.trim());
    }, 500);
    const setInputChange = useCallback((event, newInputValue) => {
        searchInputChange(newInputValue);
        setSearchValueDebounce(event, newInputValue);
    }, []);
    return (_jsx(Autocomplete, { open: isFocus && !!defaultValue, classes: {
            option: classes.option,
            ...className
        }, disabled: disabled, value: valueSelected, inputValue: defaultValue, renderInput: (params) => (_jsx(TextField, { ...params, label: '', placeholder: placeholder, variant: 'outlined', size: 'small', InputProps: {
                ...params.InputProps,
                className: 'search-box',
                startAdornment: (_jsx(InputAdornment, { position: 'start', children: _jsx(Search, {}) })),
                endAdornment: (_jsx(React.Fragment, { children: loading ? (_jsx(CircularProgress, { color: 'primary', size: 20 })) : defaultValue ? (params.InputProps.endAdornment) : null }))
            } })), openText: 'open', autoComplete: true, blurOnSelect: true, includeInputInList: true, onChange: (event, newValue) => {
            if (valueChange) {
                const value = searchAnyKeyword ? getValue(newValue) || newValue || '' : getValue(newValue);
                if (searchOptionValue) {
                    const label = getOptionLabel(newValue);
                    setValueSelected(label);
                }
                else
                    setValueSelected(value);
                valueChange(value);
                if (setPage) {
                    setPage(1);
                }
            }
        }, onInputChange: (event, newInputValue) => setInputChange(event, newInputValue), getOptionLabel: (option) => {
            const label = getOptionLabel(option);
            return searchAnyKeyword ? label || valueSelected : label;
        }, options: options, freeSolo: freeSolo, noOptionsText: noOptionsText, forcePopupIcon: false, loading: loadingText && loading, onFocus: () => setIsFocus(true), onBlur: () => setIsFocus(false) }));
};
